import { Box, Dialog, Typography } from "@mui/material";
import clsx from "clsx";
import { useTranslation } from "react-i18next";
import UpgradeConsoleImage from "../../../assets/images/upgrade-console.png";
import styles from "./UpgradeConsolePopup.module.scss";
interface IProps {
	open: boolean;
	onClose: () => void;
}

export default function UpgradeConsolePopup({ open, onClose }: IProps) {
	const { t } = useTranslation("translation", { keyPrefix: "upgradePopup.console" });

	return (
		<Dialog
			classes={{
				paper: styles.paper,
			}}
			onClose={onClose}
			open={open}
			maxWidth={false}
		>
			<Box className={styles.container}>
				<Box className={styles.content}>
					<Typography className={styles.title}>{t("title")}</Typography>
					<Box className={styles.descriptionContainer}>
						<Typography className={clsx(styles.description, styles.bold)}>{t("description1")}</Typography>
						<Typography className={styles.description}>{t("description2")}</Typography>
						<Typography className={styles.description}>{t("description3")}</Typography>
						<Typography className={clsx(styles.description, styles.italic)}>{t("description4")}</Typography>
					</Box>
				</Box>
				<Box className={styles.imageContainer}>
					<img alt="upgrade console image" src={UpgradeConsoleImage} />
				</Box>
			</Box>
		</Dialog>
	);
}
